import { CheckGroup } from 'enova-frontend-components';
import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxArea } from '../components/checkboxArea';
import { AboutFormControlProps, OppvarmingElektriskFormData } from '../../types';

import { Gulvvarme } from './gulvvarme';
import { Kjel } from './kjel';
import { Takvarme } from './takvarme';
import { Panelovn } from './panelovn';
import { Luftvarme } from './luftvarme';

const hasSelectedElektriskOppvarming = (selection?: OppvarmingElektriskFormData) =>
  selection?.gulvvarme?.selected ||
  selection?.kjel?.selected ||
  selection?.takvarme?.selected ||
  selection?.luftvarme?.selected ||
  selection?.panelovn?.selected;

const elektrisitetEmptyValue: OppvarmingElektriskFormData = {
  kjel: {
    value: undefined,
    selected: false
  },
  takvarme: {
    value: undefined,
    selected: false
  },
  luftvarme: {
    value: undefined,
    selected: false
  },
  panelovn: {
    value: undefined,
    selected: false
  },
  gulvvarme: {
    value: undefined,
    selected: false
  }
};

export const Elektrisitet: FC<AboutFormControlProps> = ({ control }) => {
  const { trigger, formState, setValue } = useFormContext();
  const { t } = useTranslation();

  const triggerElektriskOppvarmingValidation = () => {
    if (formState.isSubmitted) {
      trigger('oppvarmingSelection.oppvarmingElektrisk');
    }
  };

  return (
    <Controller
      control={control}
      name="oppvarmingSelection.oppvarmingElektrisk"
      rules={{
        validate: (value, formValues) => {
          const oppvarmingElektrisk = formValues.oppvarming?.oppvarmingElektrisk;

          // Has selected "Elektrisitet" but not selected which source
          if (value && !hasSelectedElektriskOppvarming(oppvarmingElektrisk)) {
            return t('register.tekniskUtstyr.oppvarmingElektrisk.noSelection');
          }

          return true;
        }
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <CheckboxArea
          i18nPrefix="register.tekniskUtstyr.oppvarmingElektrisitet"
          value={!!value}
          error={fieldState.error}
          onChange={(checked) => {
            onChange(checked);

            if (!checked) {
              // Reset all elektrisitet values if unchecked
              setValue('oppvarming.oppvarmingElektrisk', elektrisitetEmptyValue);
            }
          }}
        >
          <CheckGroup error={!!fieldState.error} onChange={triggerElektriskOppvarmingValidation}>
            <Panelovn control={control} />
            <Gulvvarme control={control} />
            <Kjel control={control} />
            <Takvarme control={control} />
            <Luftvarme control={control} />
          </CheckGroup>
        </CheckboxArea>
      )}
    />
  );
};
